import React from 'react'
import PropTypes from 'prop-types'


const PaymentCard = (props, {formatMessage}) => (
    <div className="payment-card payment-card--theme-default">
        <form className="payment-card__form">
            <div className="payment-card__form-group">
                <label htmlFor="">{formatMessage("Cardholder name")}</label>
                <input className="payment-card__form-control" type="text"/>
            </div>
            <div className="payment-card__form-group">
                <label className="payment-card__label-primary" htmlFor="">{formatMessage("Card number")}</label>
                <div className="payment-card__input-flex-group payment-card__input-flex-group--between">
                    <input className="payment-card__form-input-primary" type="text"/>
                    <input className="payment-card__form-input-primary" type="text"/>
                    <input className="payment-card__form-input-primary" type="text"/>
                </div>
            </div>
            <div className="payment-card__row">
                <div className="payment-card__col">
                    <div className="payment-card__form-group">
                        <label htmlFor="">{formatMessage("Expiration date")}</label>
                        <div className="payment-card__input-flex-group">
                            <input type="text"/>
                            <span className="payment-card__input-indenter">/</span>
                            <input type="text"/>
                        </div>
                    </div>
                </div>
                <div className="payment-card__col">
                    <div className="payment-card__form-group">
                        <label htmlFor="">{formatMessage("CVV number")}</label>
                        <input className="payment-card__form-control" type="text"/>
                    </div>
                </div>
            </div>
        </form>
    </div>
)

PaymentCard.contextTypes = {formatMessage: PropTypes.any}

export default PaymentCard


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Payment/PaymentCard.js